import { render } from "./ClientSpaceInvites.vue?vue&type=template&id=4073d8df&scoped=true"
import script from "./ClientSpaceInvites.vue?vue&type=script&lang=js"
export * from "./ClientSpaceInvites.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=4073d8df&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4073d8df"]])

export default __exports__